/* eslint-disable no-undef */
export const API_ENDPOINT =
  process.env.NODE_ENV === "development"
    ? "http://localhost:3001"
    : "https://live-gists.herokuapp.com";
